export const environment = {
    production: true,
    baseURL: "https://dex-backend.dexora.live/",
};
